<script>
import { defineComponent, ref } from '@vue/composition-api';

export default defineComponent({
  props: {
    eventsResults: {
      type: Object,
      default: () => ({}),
    },
  },
  setup(props) {
    const { pageView } = props.eventsResults;
    const getPercentage = (value) => `${Math.round((value / pageView) * 10000) / 100}%`;

    const eventsTitle = ref({
      pageView: 'Quantidade de acessos',
      viewProduct: 'Quantidade de produtos vistos',
      addCart: 'Adições ao carrinho',
      checkout: 'Checkouts',
    });

    return {
      getPercentage,
      eventsTitle,
    };
  },
});
</script>

<template>
  <v-container class="mt-2 pb-0">
    <v-layout
      v-for="[event, value] in Object.entries(eventsResults)"
      :key="event"
      align-center
      column
      class="mb-4"
    >
      <div
        class="graph__bar"
        :style="{ width: getPercentage(value) }"
      >
        <span class="graph__bar__value">
          {{ value || 0 }} / {{ getPercentage(value).replace('.', ',') }}
        </span>
      </div>
      <span class="graph__event-name pt-1">
        {{ eventsTitle[event] }}
      </span>
    </v-layout>
  </v-container>
</template>

<style lang="scss">
.graph {
  &__bar {
    display: flex;
    justify-content: center;
    background-color: #FFADDE;
    height: 30px;
    border-radius: 8px;
    &__value {
      transform: translateY(-8px);
      position: absolute;
      border-radius: 4px;
      font-size: 12px;
      font-family: 'Nunito Sans';
      padding: 2px 6px;
      background-color: white;
    }
  }
  &__event-name {
    font-size: 14px;
    font-family: 'Nunito Sans';
  }
}
</style>
